/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { PutCall } from './PutCall';
import {
    PutCallFromJSON,
    PutCallFromJSONTyped,
    PutCallToJSON,
} from './PutCall';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * 
 * @export
 * @interface OptionsCreateRequest
 */
export interface OptionsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OptionsCreateRequest
     */
    description: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof OptionsCreateRequest
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof OptionsCreateRequest
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof OptionsCreateRequest
     */
    subAssetType: SubAssetType;
    /**
     * 
     * @type {string}
     * @memberof OptionsCreateRequest
     */
    underlyingSymbol: string;
    /**
     * 
     * @type {string}
     * @memberof OptionsCreateRequest
     */
    expirationDate: string;
    /**
     * 
     * @type {number}
     * @memberof OptionsCreateRequest
     */
    strikePrice: number;
    /**
     * 
     * @type {PutCall}
     * @memberof OptionsCreateRequest
     */
    putCall: PutCall;
    /**
     * 
     * @type {number}
     * @memberof OptionsCreateRequest
     */
    priceMultiplier: number;
    /**
     * 
     * @type {number}
     * @memberof OptionsCreateRequest
     */
    contractMultiplier: number;
}



/**
 * Check if a given object implements the OptionsCreateRequest interface.
 */
export function instanceOfOptionsCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "subAssetType" in value;
    isInstance = isInstance && "underlyingSymbol" in value;
    isInstance = isInstance && "expirationDate" in value;
    isInstance = isInstance && "strikePrice" in value;
    isInstance = isInstance && "putCall" in value;
    isInstance = isInstance && "priceMultiplier" in value;
    isInstance = isInstance && "contractMultiplier" in value;

    return isInstance;
}

export function OptionsCreateRequestFromJSON(json: any): OptionsCreateRequest {
    return OptionsCreateRequestFromJSONTyped(json, false);
}

export function OptionsCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionsCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': SubAssetTypeFromJSON(json['sub_asset_type']),
        'underlyingSymbol': json['underlying_symbol'],
        'expirationDate': json['expiration_date'],
        'strikePrice': json['strike_price'],
        'putCall': PutCallFromJSON(json['put_call']),
        'priceMultiplier': json['price_multiplier'],
        'contractMultiplier': json['contract_multiplier'],
    };
}

export function OptionsCreateRequestToJSON(value?: OptionsCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'underlying_symbol': value.underlyingSymbol,
        'expiration_date': value.expirationDate,
        'strike_price': value.strikePrice,
        'put_call': PutCallToJSON(value.putCall),
        'price_multiplier': value.priceMultiplier,
        'contract_multiplier': value.contractMultiplier,
    };
}

